import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class cookies {
  constructor() {
    _defineProperty(this, "getCookie", function (name) {
      let nameEQ = name + "=";
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    });
    _defineProperty(this, "eraseCookie", function (name) {
      document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    });
  }
  setCookie(name, value, days, expiresValue) {
    let expires = "";
    let expireDate = null;
    if (expiresValue) {
      expires = "; expires=" + expiresValue;
    } else {
      if (days) {
        expireDate = new Date();
        expireDate.setTime(expireDate.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + expireDate.toUTCString();
      }
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
    return expireDate === null ? null : expireDate.toUTCString();
  }
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/cookies', cookies);